import _ from 'lodash';

export const formatMemberCountLabel = memberCount => {
  if (_.isNil(memberCount)) {
    return null;
  }

  const noun = memberCount === 1 ? 'member' : 'members';

  return `${memberCount} ${noun}`;
};

export const formatOnlineCountLabel = ({ onlineCount, totalCount }) => {
  if (_.isNil(onlineCount) || _.isNil(totalCount) || totalCount <= 0) {
    return null;
  }

  return `${onlineCount}/${totalCount} online`;
};
